// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_PEOPLE_THINK_IT_IS_USEFUL = ["%(count)s \u010dlov\u011bk pova\u017euje za u\u017eite\u010dn\u00e9", "%(count)s lid\u00e9 pova\u017euj\u00ed za u\u017eite\u010dn\u00e9", "%(count)s lid\u00ed pova\u017euje za u\u017eite\u010dn\u00e9"];
export const DELETE_REVIEW_REPLY = "Sma\u017e odpov\u011b\u010f";
export const USEFUL = "U\u017eite\u010dn\u00e9";
